import { render, staticRenderFns } from "./TouchRipple.vue?vue&type=template&id=7f84a63a&scoped=true&"
import script from "./TouchRipple.vue?vue&type=script&lang=js&"
export * from "./TouchRipple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84a63a",
  null
  
)

export default component.exports